import * as actions from './actionTypes';
import authService from '../services/authService';
import { showNotification } from './actions';

export const login = (username, password) => async (dispatch) => {
    dispatch({ type: actions.LOGIN_REQUEST });
    
    const result = await authService.login(username, password);
    
    if (result.success) {        
        dispatch({ 
            type: actions.LOGIN_SUCCESS, 
            payload: result.data 
        });
        dispatch(showNotification('Вход выполнен успешно', 'success'));
        return true;
    } else {
        dispatch({ 
            type: actions.LOGIN_FAILURE, 
            payload: result.error 
        });
        dispatch(showNotification(result.error, 'error'));
        return false;
    }
};

export const logout = () => (dispatch) => {
    authService.logout();
    dispatch({ type: actions.LOGOUT });
    dispatch(showNotification('Вы вышли из системы', 'success'));
};